function stripTrailingSlash(value) {
    return String(value || "").replace(/\/+$/, "");
}

function isLoopbackUrl(value) {
    const v = String(value || "").toLowerCase();
    return (
        v.includes("://localhost") ||
        v.includes("://127.0.0.1") ||
        v.includes("://[::1]") ||
        v.startsWith("localhost") ||
        v.startsWith("127.0.0.1") ||
        v.startsWith("[::1]")
    );
}

function resolveApiBase() {
    const raw = stripTrailingSlash(process.env.REACT_APP_API_URL);
    const isProd = process.env.NODE_ENV === "production";

    if (!raw) {
        // In dev, default to the local server. In prod, require explicit config.
        return isProd ? "" : "http://localhost:5050";
    }

    if (isProd && isLoopbackUrl(raw)) {
        // Production builds must never call loopback.
        return "";
    }

    return raw;
}

export const API_BASE = resolveApiBase();

export function ensureApiBaseConfigured() {
    const isProd = process.env.NODE_ENV === "production";
    const raw = stripTrailingSlash(process.env.REACT_APP_API_URL);

    if (isProd && raw && isLoopbackUrl(raw)) {
        // This should surface loudly in logs for misconfigured Netlify env vars.
        // We don't throw to avoid a blank screen; components can show a fallback.
        // eslint-disable-next-line no-console
        console.error(
            "Misconfigured REACT_APP_API_URL: production build is pointing to a loopback address. Set REACT_APP_API_URL to your deployed API (e.g. Render) in Netlify environment variables."
        );
    }
}

